<template>
  <v-stepper
    v-if="flowItems?.length > 0"
    v-model="step"
    vertical
    class="elevation-0"
  >
    <template v-for="(item, index) in flowItems">
      <!-- step -->
      <v-stepper-step
        :key="`${item.id}_STEP`"
        :step="index + 1"
        :complete="!!item.completed"
        :editable="(selectable && !item.disabled) || index + 1 < step"
        edit-icon="$complete"
        :rules="[() => !isItemMissing(item)]"
      >
        {{ item.name }}
        <small v-if="item.info">{{ item.info }}</small>
        <small v-if="isItemMissing(item)">fehlt</small>
      </v-stepper-step>

      <!-- content -->
      <v-stepper-content
        :key="`${item.id}_CONTENT`"
        :step="index + 1"
        :class="{ active: step === index + 1 }"
      >
        <slot :name="`content.${item.id}`" />
      </v-stepper-content>
    </template>
  </v-stepper>
  <div v-else class="text-center caption">
    {{ $t('fresh-vue-cards.misc.no-steps') }}
  </div>
</template>

<script>
export default {
  name: 'ProcessFlowStepper',

  props: {
    value: {
      type: String,
      required: false,
      default: null
    },

    flowItems: {
      type: Array,
      required: false,
      default: null
    },

    selectable: {
      type: Boolean,
      required: false,
      default: false
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      step: null
    }
  },

  watch: {
    value: {
      handler(value) {
        this.step = this.getFlowStep(value)
      },
      immediate: true
    },

    step(step) {
      this.$emit('input', this.getFlowId(step))
    }
  },

  methods: {
    isItemMissing(item) {
      return !item.disabled && item.required && !item.completed
    },

    getFlowStep(id) {
      if (id) {
        const topLevelFlowId = this.findFlowItemId(this.flowItems, id)
        if (topLevelFlowId) {
          const index = this.flowItems?.findIndex(
            (item) => item.id === topLevelFlowId
          )

          if (index != -1) {
            return index + 1
          }
        }
      }

      return 0
    },

    getFlowId(step) {
      if (step > 0) {
        return this.flowItems?.[step - 1]?.id ?? null
      }
      return null
    },

    findFlowItemId(items, queryId) {
      if (!items) {
        return null
      }

      var found = items.some((i) => i.id === queryId)

      if (found) {
        // we can stop the recursive part, if the item we are looking for is in the current iteration
        return queryId
      } else {
        // otherwise we have to look in the children
        for (var i = 0; i < items.length; i++) {
          const item = items[i]
          const found = this.findFlowItemId(item.children, queryId)
          if (found) {
            return item.id
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.v-stepper__content.active) > .v-stepper__wrapper {
  height: auto !important;
}
</style>
